module.exports = __webpack_public_path__ + "static/media/close_thick.5ef24dd7.svg";